<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400" width="800" height="400">
  <defs>
    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#6A11CB" />
      <stop offset="100%" stop-color="#2575FC" />
    </linearGradient>
    
    <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="8" />
      <feOffset dx="4" dy="4" result="offsetblur" />
      <feFlood flood-color="#3a3a3a" flood-opacity="0.15" />
      <feComposite in2="offsetblur" operator="in" />
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>  
  </defs>
  
  <!-- Clean white background -->
  <rect width="100%" height="100%" fill="#fff" />
  
  <!-- Main content container -->
  <g transform="translate(400, 200)">
    <!-- Cake illustration -->
    <g class="fade-in" filter="url(#shadow)">
      <!-- Plate -->
      <ellipse cx="0" cy="50" rx="80" ry="12" fill="#f5f5f7" />
      <ellipse cx="0" cy="50" rx="70" ry="8" fill="#fff" stroke="#e4e4e7" stroke-width="1" />
      
      <!-- Empty cake tiers (outline only) -->
      <path d="M -50 30 Q 0 -20 50 30 L 50 -10 Q 0 -60 -50 -10 Z" 
            fill="none" stroke="#e4e4e7" stroke-width="3" stroke-dasharray="6,4" />
      <path d="M -40 -10 Q 0 -50 40 -10 L 40 -40 Q 0 -80 -40 -40 Z" 
            fill="none" stroke="#e4e4e7" stroke-width="3" stroke-dasharray="6,4" />
    </g>
    
    <!-- Magnifying glass -->
    <g class="fade-in" transform="translate(0, -30)" filter="url(#shadow)">
      <circle cx="0" cy="0" r="40" fill="none" stroke="url(#gradient)" stroke-width="4" />
      <line x1="30" y1="30" x2="60" y2="60" stroke="url(#gradient)" stroke-width="4" />
    </g>
    
    <!-- Text -->
    <text x="0" y="150" text-anchor="middle" font-family="Arial, sans-serif" font-size="36" font-weight="600" fill="#333">
      No cakes found
    </text>
    <text x="0" y="190" text-anchor="middle" font-family="Arial, sans-serif" font-size="18" fill="#666">
      We're fresh out of baked goods
    </text>
  </g>
  
  <!-- Decorative elements -->
  <g opacity="0.6">
    <circle cx="100" cy="100" r="8" fill="url(#gradient)" />
    <circle cx="700" cy="300" r="6" fill="url(#gradient)" />
    <circle cx="650" cy="100" r="4" fill="url(#gradient)" />
    <circle cx="150" cy="320" r="5" fill="url(#gradient)" />
  </g>
</svg>
</template>
<style scoped>
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .fade-in { animation: fadeIn 1.2s ease-out; }
</style>